import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OpenIdService } from '../services';

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (typeof window === 'undefined') {
    return next(req);
  }

  const openIdService = inject(OpenIdService, { optional: true });
  if (!openIdService) {
    return next(req);
  }

  return from(openIdService.getAccessToken()).pipe(
    switchMap((token) => {
      const authenticatedReq = req.clone({
        withCredentials: true,
        ...(token ? { setHeaders: { Authorization: `Bearer ${token}` } } : {}),
      });

      return next(authenticatedReq);
    }),
  );
};
